import { administrationModule, attestBookModule, booksModule, reportModule } from "./shared"


export const kindergartenData = [
  {
    iconComponent: 'so-icon',
    title: 'СПИСЪК-ОБРАЗЕЦ',
    details: [
      {
        text: 'Актуализиране и изпращане на данни от и към НЕИСПУО винаги, когато е необходимо'
      },
      {
        text: 'Въвеждане на данните за списък-образец № 2 в интуитивна електронна среда '
      },
      {
        text: 'Преглеждане на архив на списък-образците от предходни години, ако са били създадени с модула'
      },
    ]
  },
  {
    iconComponent: 'kindergarten-icon',
    title: 'ЕЛЕКТРОНЕН<br>ДНЕВНИК',
    details: [
      {
        text: 'Администриране на целия процес по водене на електронните дневници съгласно Наредба № 8 от 11.08.2016 г.'
      },
      {
        text: 'Двустранна интеграция с НЕИСПУО'
      },
      {
        text: 'Готови тематични разпределения от всички издателства, които предоставят учебно съдържание за детските градини'
      },
      {
        text: 'Архив от минали години и генериране на PDF файл на дневниците'
      },
    ]
  },
  {
    iconComponent: 'tax-meals-icon',
    title: 'ТАКСИ',
    details: [
      {
        text: 'Определяне размера на таксите за посещение на детските градини (за частни детски градини) и за допълнителните дейности, както и начина на изчисляване'
      },
      {
        text: 'Преглед и зареждане на месечни такси за посещение на детската градина и за допълнителните дейности, преизчисляване на такса и маркиране на платена/неплатена такса'
      },
      {
        text: 'Преглед на цялата въведена информация в модула от родителите за тяхното дете'
      },
    ]
  },
  {
    iconComponent: 'nutrition-icon',
    title: 'ХРАНЕНЕ',
    details: [
      {
        text: 'Преглед на предварително заредени хранителни продукти с възможност за добавяне на нов хранителен продукт и отбелязване на алергени'
      },
      {
        text: 'Проследяване движението на хранителни продукти –заприходяване и изразходване'
      },
      {
        text: 'Създаване на седмично меню за всяка група, като създаденото седмично меню може да бъде копирано и на друга група'
      },
    ]
  },
  reportModule,
  {
    iconComponent: 'diploma-icon',
    title: 'ДИПЛОМИ',
    details: [
      {
        text: 'Отпечатване в програмата АдминДГ на Удостоверението за завършено предучилищно образование (ном. номер 3-19)'
      },
      {
        text: 'Автоматично зареждане на данните за децата за целите на отпечатване на Удостоверението за завършено предучилищно образование – за абонати на модул „Електронен дневник“ от платформата АдминПлюс'
      },
      {
        text: 'Прецизиране на текста за печат спрямо бланката на документа'
      },
      {
        text: 'Създаване на експортен файл за качване в НЕИСПУО'
      },
    ]
  },
  {
    iconComponent: 'documents-icon',
    title: 'ДОКУМЕНТАЦИЯ <br>ЗА ДЕТСКАТА ГРАДИНА',
    details: [
      {
        text: 'Примерни документи за администриране на различни процеси в детските градини'
      },
      {
        text: 'Експорт на примерните документи в PDF и DOC формат'
      },
      {
        text: 'Разпечатване в неограничен брой копия на всеки документ'
      },
      {
        text: 'Нормативна уредба в системата на образованието'
      },
    ]
  },
  booksModule,
  attestBookModule,
  {
    iconComponent: 'calendar-icon',
    title: 'КАЛЕНДАР НА<br>СЪБИТИЯТА',
    details: [
      {
        text: 'Въвеждане на информация за всякакви събития – родителска среща, консултации и други събития'
      },
      {
        text: 'Достъп на родителите до модула'
      },
      {
        text: 'Справки по вид събитие'
      },
    ]
  },
  {
    iconComponent: 'messages-icon',
    title: 'СЪОБЩЕНИЯ',
    details: [
      {
        text: 'Вътрешна мрежа за обмен на съобщения между учители, родители и администрация'
      },
      {
        text: 'Създаване на потребителски групи'
      },
      {
        text: 'Препращане на съобщения'
      },
    ]
  },
  {
    iconComponent: 'mobile-icon',
    title: 'МОБИЛНО<br>ПРИЛОЖЕНИЕ',
    details: [
      {
        text: 'Въвеждане и преглед на основната информация от учителя'
      },
      {
        text: 'Информиране за различни събития в институцията'
      },
      {
        text: 'Известия за учители и родители'
      },
    ]
  },
  administrationModule
]
